<template>
  <div>
    <label class="tw-font-medium">Display</label>
    <div>
      <div class="tw-flex tw-flex-col tw-gap-2">
        <div
          v-for="option in options"
          :key="option.value"
          @click="updateChartType(option.value)"
        >
          <SidebarButton
            :option="option"
            :is-selected="selectedOption.value === option.value"
            :show-checkmark="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarButton from './SidebarButton.vue';

export default {
  name: 'ChartToggle',
  components: {
    SidebarButton,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return { selectedOption: this.options[0] };
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    updateChartType(value) {
      this.selectedOption = this.options.find(option => option.value === value);
      console.log(`Chart type updated to: ${value}`);
      // Emit a @change event
      this.$emit('change', value);
    },
  },
};
</script>
